import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import MasterCourseList from '../../components/master-course-list/index';
import {
    getCountriesWithMasterCourses,
    changeMasterCourseCountry,
    getSubjects,
    changeSubject,
    changeCurriculumType,
    getMasterCourses } from './actions';

import {
    GLOBAL_CURRICULUM_ID,
    COUNTRY_CURRICULUM_ID,
    DEFAULT_DROPDOWN_ID
} from '../../constants';

class MasterCourseContainer extends PureComponent {
    static propTypes = {
        countries: PropTypes.array,
        courses: PropTypes.array,
        getCountriesWithMasterCourses: PropTypes.func,
        changeMasterCourseCountry: PropTypes.func,
        countryLoaded: PropTypes.bool,
        selectedCountry: PropTypes.string,
        subjects: PropTypes.array,
        getSubjects: PropTypes.func,
        subjectLoaded: PropTypes.bool,
        changeSubject: PropTypes.func,
        selectedSubject: PropTypes.string,
        changeCurriculumType: PropTypes.func,
        curriculumType: PropTypes.string,
        getMasterCourses: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.handleCountryOnChange = this.handleCountryOnChange.bind(this);
        this.handleSubjectOnChange = this.handleSubjectOnChange.bind(this);
        this.handleCurriculumTypeOnChange = this.handleCurriculumTypeOnChange.bind(this);
        this.filterCoursesByCountry = this.filterCoursesByCountry.bind(this);
    }

    componentDidMount() {
        if (!this.props.countryLoaded) {
            this.props.getCountriesWithMasterCourses();
        }
        if (!this.props.subjectLoaded) {
            this.props.getSubjects();
        }
    }

    handleCurriculumTypeOnChange = (collectionName, key) => {
        this.props.changeCurriculumType(key);
        if (key === GLOBAL_CURRICULUM_ID || key === COUNTRY_CURRICULUM_ID) {
            this.props.getMasterCourses({ accessStatus: key });
        }
    }

    handleCountryOnChange = (collectionName, key) => {
        this.props.changeMasterCourseCountry(key);
    };

    filterCoursesByCountry = () => {
        let courses = this.props.courses;

        if (this.props.selectedCountry !== '' && this.props.selectedCountry !== DEFAULT_DROPDOWN_ID) {
            courses = courses.filter(course => course.countryCode === this.props.selectedCountry);
        }
        return courses;
    }

    handleSubjectOnChange = (collectionName, key) => {
        this.props.changeSubject(key);
    };

    render() {
        const filteredCourses = this.filterCoursesByCountry();
        return (
            <MasterCourseList
                countries={this.props.countries}
                courses={filteredCourses}
                curriculumType={this.props.curriculumType}
                handleCountryOnChange={this.handleCountryOnChange}
                handleCurriculumTypeOnChange={this.handleCurriculumTypeOnChange}
                selectedCountry={this.props.selectedCountry}
                subjects={this.props.subjects}
                selectedSubject={this.props.selectedSubject}
                handleSubjectOnChange={this.handleSubjectOnChange}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state,
        countries: state.masterCourses.countries,
        courses: state.masterCourses.courses,
        countryLoaded: state.masterCourses.countryLoaded,
        selectedCountry: state.masterCourses.selectedCountry,
        subjects: state.masterCourses.subjects,
        subjectLoaded: state.masterCourses.subjectLoaded,
        selectedSubject: state.masterCourses.selectedSubject,
        curriculumType: state.masterCourses.curriculumType
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCountriesWithMasterCourses,
        changeMasterCourseCountry,
        getSubjects,
        changeSubject,
        changeCurriculumType,
        getMasterCourses
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MasterCourseContainer));



// WEBPACK FOOTER //
// ./app/containers/master-courses/index.js